export enum JobPriorityType {
  NONE,
  LOW,
  MEDIUM,
  HIGH,
  CRITICAL
}

export enum JobPriorityLabelType {
  NONE = 'None',
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  CRITICAL = 'Critical'
}
